// IntersectionObserver-driven reveal-on-scroll. Adds .is-revealed when an
// element enters the viewport. Pure progressive enhancement — elements
// without the data attribute are unaffected.

export function initRevealOnScroll() {
	const targets = document.querySelectorAll('[data-cs-reveal]');
	if (!targets.length || !('IntersectionObserver' in window)) {
		targets.forEach((t) => t.classList.add('is-revealed'));
		return;
	}

	const obs = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('is-revealed');
				obs.unobserve(entry.target);
			}
		});
	}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

	targets.forEach((t) => obs.observe(t));
}
